import { render, staticRenderFns } from "./UnsyncedMessage.vue?vue&type=template&id=1e8856e9&scoped=true"
import script from "./UnsyncedMessage.vue?vue&type=script&lang=js"
export * from "./UnsyncedMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8856e9",
  null
  
)

export default component.exports